import { useMemo } from 'react'

import { useCurrentUser } from '../../hooks/users'
import useDataManager from './useDataManager'

export default function useManagedCurrentUser() {
  const { users } = useDataManager()
  const userId = useCurrentUser().synopUser?.id
  const { data, isLoading, isFetching } = users

  const currentUser = useMemo(() => data.find((user) => user.id === userId), [data, userId])
  return { currentUser, isLoading, isFetching }
}
